const isOnlyDigits = (str: string | number): boolean => typeof str === 'number' || /^\d+$/.test(String(str));

export default isOnlyDigits;
